import React from 'react'
import './Aboutpage.css'

function Aboutpage() {
  return (
    <div className='about'>
        <div className='information'>
          <h1>Company Information</h1>
          <p>Welcome to our website! We are a team of dedicated professionals who are passionate about providing high-quality Websites and Electronic products to our customers. Our mission is to exceed customer expectations and deliver exceptional value.</p>
        </div>
        <div className="history">
          <h1>Company History</h1>
          <p>Our company was founded in 2023 by Mr Dickson Anietie. Since then, we have been committed to delivering excellence in everything we do. Over the years, we have grown and expanded our offerings, but our core values remain the same - integrity, innovation, and customer satisfaction.</p>
        </div>
        <div className="team">
          <h1>Our Team</h1>
          <p>We have assembled a talented team with diverse backgrounds and expertise. Each member brings unique skills and perspectives that contribute to our success. Together, we work collaboratively to serve our customers and achieve our goals.</p>
        </div>
        <div className="contact">
          <h1>Contact Us</h1>
          <p>If you have any questions or inquiries, please don't hesitate to reach out to us. You can contact us at +2348111145892 or email us at brillstacktechnologies@gmail.com. We look forward to hearing from you!</p>
        </div>

      
    </div>
  )
}

export default Aboutpage;
